import types from '../types'
import api from '@/pages/comet/api'
import storage from '@/utils/storage'

const initQuestion = {
  question_id: null,
  // html_head: '',
  html_subquestion: [],
  // html_parameters: '',
  // html_analysis: null,
  // // 小问类型
  question_type: [],
  // has_analysis: false,
  // interesting: 0,
  // top: 0,
  // self_interesting: 0,
  // self_top: 0,
  // is_right: 0,
  // // submitted
  result_type: [],
  right_answer: [],
  user_answer: []
  // submitted: false,
  // // 是否查看解析
  // paid_result: 0
}
const list = []
function initSubAnswers (length, userAnswer, qId) {
  const answers = storage.get('answer_answers') || {}
  let subAnswers = []
  for (let i = 0; i < length; i++) {
    let localAnswer = answers[qId]
    let answer = ''
    let id = i
    if (userAnswer && userAnswer[i] && userAnswer[i].answer.toString().length > 0) {
      answer = userAnswer[i].answered ? userAnswer[i].answer : ''
      id = userAnswer[i].question_index
    }

    if (localAnswer) {
      if (!userAnswer) {
        userAnswer = []
        for (let i = 0; i < length; i++) {
          userAnswer[i] = {
            answer: 0,
            answered: 0,
            is_right: 0,
            question_id: qId,
            question_index: i
          }
        }
      }
      answer = localAnswer[i].answer
      const userAnswerTemp = userAnswer
      userAnswerTemp[i].answer = answer
      userAnswer = Object.assign({}, userAnswerTemp)
    }
    subAnswers[i] = {
      id: id,
      answer
    }
  }
  return {
    subAnswers: subAnswers,
    userAnswer: userAnswer
  }
}
const state = {
  examSubmitted: false,
  publishAnswer: false,
  subquestionIndex: 0,
  questionIndex: 0,
  questions: [],
  questionsIds: [],
  question: {},
  questionIndexMap: {},
  questionList: [],
  subAnswers: [],
  answerIsInvalid: false,
  dispatchingMultiQuestions: false,
  question_type: 0
}

const getters = {
  examSubmitted: state => state.examSubmitted,
  publishAnswer: state => state.publishAnswer,
  submitted: (state, getters) => {
    return !!getters.question.submitted
  },
  questionType: state => state.questionType,
  answerIsInvalid: state => state.answerIsInvalid,
  subAnswers: state => state.subAnswers || [],
  questionList: state => state.questionList || [],
  questionIndexMap: state => state.questionIndexMap || [],
  question: state => state.question || {},
  questionListLength: state => state.questionList.length || 0,
  subquestionIndex: state => {
    return state.subquestionIndex || 0
  },
  questionIndex: state => {
    return state.questionIndex || 0
  },
  isRight: (state, getters) => {
    return !!getters.question.is_right && getters.question.submitted
  },
  paidResult: (state, getters) => {
    return !!getters.question.paid_result
  },
  dispatchingMultiQuestions: state => state.dispatchingMultiQuestions
}

const mutations = {
  [types.CHANGE_SUBMIT_STATUS] (state, payload) {
    state.examSubmitted = payload
  },
  [types.CHANGE_PUBLISH_STATUS] (state, payload) {
    state.publishAnswer = payload
  },
  [types.UPDATE_QUESTIONS_LIST] (state, { questionList }) {
    state.questionList = questionList
  },
  [types.CHANGE_QUESTIONS_LIST] (state, { questionList, questionType }) {
    state.questionType = questionType
    let map = {}
    questionList.forEach((item, i) => {
      map[item.question_id] = i
    })
    state.questionList = questionList || list
    state.questionIndexMap = map
  },
  [types.CHANGE_QUESTIONS] (state, { questions }) {
    const questionId = state.questionList[state.questionIndex].question_id
    state.questions = questions || []
    state.questionsIds = questions.map(item => item.question_id)
    const question = questions.filter(item => item.question_id === questionId)[0] || initQuestion
    const initData = initSubAnswers(question.html_subquestion.length, question.user_answer, question.question_id)
    question.user_answer = initData.userAnswer
    state.question = question
    state.subAnswers = initData.subAnswers
  },
  [types.CHANGE_QUESTION] (state, { question }) {
    const questions = state.questions
    questions.forEach((item, i) => {
      if (item.question_id === question.question_id) {
        questions[i] = question
      }
    })
    state.question = question
    state.questions = [...questions]
  },
  [types.CHANGE_QUESTION_INDEX] (state, { questionIndex }) {
    const questionId = state.questionList[questionIndex].question_id
    const question = state.questions.filter(item => item.question_id === questionId)[0]
    if (question) {
      const initData = initSubAnswers(question.html_subquestion.length, question.user_answer, question.question_id)
      question.user_answer = initData.userAnswer
      state.subAnswers = initData.subAnswers
      state.question = question
    }
    state.questionIndex = questionIndex
  },
  [types.CHANGE_SUB_ANSWER] (state, { index, answer }) {
    const answers = storage.get('answer_answers') || {}
    let subAnswers = state.subAnswers
    subAnswers[index] = { id: index, answer: answer }
    state.subAnswers = [...subAnswers]
    answers[state.question.question_id] = subAnswers
    storage.set('answer_answers', answers)
  },
  [types.CHANGEING_QUESTIONS] (state, { res }) {
    state.dispatchingMultiQuestions = res
  },
  [types.CHANGE_SUBQUESTION_INDEX] (state, { subquestionIndex }) {
    state.subquestionIndex = subquestionIndex
  },
  [types.CHANGE_ANSWER_INVALID] (state, { answerIsInvalid }) {
    state.answerIsInvalid = answerIsInvalid
  },
  [types.CLEAR_QUESTION] (state, { question }) {
    const questions = state.questions
    questions.forEach((item, i) => {
      if (item.question_id === question.question_id) {
        questions[i] = question
      }
    })
    state.question = question
    state.questions = [...questions]
  }
}
function getIdsByIndex (index, list) {
  const counts = 5
  const i = index - (index % counts)
  const e = i + counts
  const listTemp = list.slice(i, e)
  return listTemp.map(item => item.question_id)
}
const actions = {
  // 更新试卷提交状态
  updateExamSubmitStatus ({ commit, state }, payload) {
    commit(types.CHANGE_SUBMIT_STATUS, payload)
  },
  // 更新试卷公布答案状态
  updateExamPublishStatus ({ commit, state }, payload) {
    commit(types.CHANGE_PUBLISH_STATUS, payload)
  },
  getGetMultiQuestions ({ commit, state }, payload) {
    commit(types.CHANGEING_QUESTIONS, {
      res: true
    })
    // 获取题目
    api.questionGetMultiQuestions(payload).then(res => {
      const data = res.data.data || []
      //   const questions = res.data.data || []
      const ids = payload.params.questions.split(',') || []
      const questions = ids.map(item => {
        return data.find(findItem => +findItem.question_id === +item) || {}
      })
      commit(types.CHANGE_QUESTIONS, {
        questions: questions || []
      })
      //   const qid = state.questionList[state.questionIndex].question_id
      //   const activeQuestion = questions.filter(item => item.question_id === qid)[0] || {}
      this.dispatch('answer/updateQuestionListItem', {
        // submitted: activeQuestion.submitted,
        // is_right: activeQuestion.is_right
      })
      commit(types.CHANGEING_QUESTIONS, {
        res: false
      })
    }, () => {
      commit(types.CHANGEING_QUESTIONS, {
        res: false
      })
    })
  },
  updateQuestionList ({ commit, state }, payload) {
    commit(types.CHANGE_QUESTIONS_LIST, {
      questionList: payload.questionList,
      questionType: payload.question_type
    })
  },
  updateQuestionListItem ({ commit, state }, item) {
    let list = state.questionList
    const originItem = list[state.questionIndex]
    list[state.questionIndex] = Object.assign({}, originItem, item)
    commit(types.UPDATE_QUESTIONS_LIST, {
      questionList: [...list]
    })
  },
  //   getList ({ commit }, payload) {
  //     // 获取题目列表
  //     console.log(33333)
  //     api.questionGetList(payload).then(res => {
  //       commit(types.CHANGE_QUESTIONS_LIST, {
  //         questionList: res.data.data || list,
  //         questionType: payload.question_type
  //       })
  //     })
  //   },
  submitQuestion ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      // 提交
      api.questionSubmit(payload).then(res => {
        if (res.data && res.data.code === 1) {
          const ids = getIdsByIndex(state.questionIndex, state.questionList)
          this.dispatch('answer/getGetMultiQuestions', { params: {
            questions: ids.join(','),
            question_type: payload.data.question_type
          } })
        }
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  payForResult ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      api.questionPayForResult(payload).then(res => {
        if (res.data.code === 1) {
          this.dispatch('answer/getGetMultiQuestions', { params: {
            questions: state.questionsIds.join(','),
            question_type: payload.params.question_type
          } })
        }
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  addWrongQuestion ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.addWrongQuestion(payload).then(res => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  updateQuestionIndex ({ commit, state }, payload) {
    if (state.questionList.length <= 0) {
      return false
    }
    const nextId = state.questionList[payload.index].question_id
    if (!state.questionsIds.includes(nextId)) {
      if (state.dispatchingMultiQuestions) {
        return false
      }
      // const ids = getIdsByIndex(payload.index, state.questionList)
      const ids = state.questionList.map(item => item.question_id)
      this.dispatch('answer/getGetMultiQuestions', { params: {
        questions: ids.join(','),
        question_type: 1,
        exam_id: +payload.examId,
        class_id: +payload.classId,
        subclass_id: +payload.subclassId
      } }).then(res => {
        commit(types.CHANGE_QUESTION_INDEX, {
          questionIndex: payload.index
        })
        commit(types.CHANGE_SUBQUESTION_INDEX, {
          subquestionIndex: 0
        })
      })
    } else {
      commit(types.CHANGE_QUESTION_INDEX, {
        questionIndex: payload.index
      })
      commit(types.CHANGE_SUBQUESTION_INDEX, {
        subquestionIndex: 0
      })
    }
  },
  submitAnswer ({ commit }, { index, answer, examId, classId, subclassId }) {
    api.submitAnswer({
      data: {
        work_id: +examId,
        class_id: +classId,
        subclass_id: +subclassId,
        id: +state.question.question_id,
        sub_id: +index,
        answer: +answer
      }
    })
  },
  updateSubAnswer ({ commit }, { index, answer, examId, classId, subclassId }) {
    // api.submitAnswer({ data: {
    //   work_id: +examId,
    //   class_id: +classId,
    //   subclass_id: +subclassId,
    //   id: +state.question.question_id,
    //   sub_id: +index,
    //   answer: +answer
    // } })
    commit(types.CHANGE_SUB_ANSWER, {
      index,
      answer
    })
  },
  updateQuestion ({ commit, state }, payload) {
    commit(types.CHANGE_QUESTION, {
      question: Object.assign({}, state.question, payload)
    })
    commit(types.CHANGE_SUBQUESTION_INDEX, {
      subquestionIndex: 0
    })
  },
  updateSubquestionIndex ({ commit, state }, payload) {
    commit(types.CHANGE_SUBQUESTION_INDEX, {
      subquestionIndex: payload
    })
  },
  clearQuestion ({ commit }) {
    commit(types.CLEAR_QUESTION, {
      subquestionIndex: 0,
      questionIndex: 0,
      questions: [],
      questionsIds: [],
      question: {},
      questionIndexMap: {},
      questionList: [],
      subAnswers: [],
      answerIsInvalid: false,
      dispatchingMultiQuestions: false,
      question_type: 0
    })
  },
  invalidAnswer ({ commit }, answerIsInvalid) {
    commit(types.CHANGE_ANSWER_INVALID, {
      answerIsInvalid
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
